import { render } from "./DetailCenter.vue?vue&type=template&id=adf8f178&scoped=true"
import script from "./DetailCenter.vue?vue&type=script&lang=js"
export * from "./DetailCenter.vue?vue&type=script&lang=js"

import "./DetailCenter.vue?vue&type=style&index=0&id=adf8f178&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-adf8f178"]])

export default __exports__